"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchesOverview = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const luxon_1 = require("luxon");
const Col_1 = require("@amzn/atoz-web/Col");
const Row_1 = require("@amzn/atoz-web/Row");
const Text_1 = require("@amzn/atoz-web/Text");
const DateManagement_1 = require("../../../../../../utils/DateManagement");
const PunchesOverviewTypes_1 = require("./PunchesOverviewTypes");
const showNextDay_1 = require("./showNextDay");
const PunchesOverview = ({ selectedDate, punchesTimeSegments }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const renderPunchInColumn = () => (react_1.default.createElement(Col_1.Col, null,
        react_1.default.createElement(Text_1.Text, { fontSize: "T200", color: "neutral50" }, t('time_and_attendance_PunchTile_in')),
        punchesTimeSegments.map(({ startDateTime }, index) => (react_1.default.createElement(Text_1.Text, { key: `punchIn-${index}` }, (0, DateManagement_1.getTimeString)(luxon_1.DateTime.fromISO(startDateTime), true))))));
    const renderPunchOutColumn = () => (react_1.default.createElement(Col_1.Col, null,
        react_1.default.createElement(Text_1.Text, { fontSize: "T200", color: "neutral50" }, t('time_and_attendance_PunchTile_out')),
        punchesTimeSegments.map(({ endDateTime }, index) => (react_1.default.createElement(Text_1.Text, { key: `punchOut-${index}` },
            (0, DateManagement_1.getTimeString)(luxon_1.DateTime.fromISO(endDateTime), true),
            (0, showNextDay_1.showNextDay)(luxon_1.DateTime.fromISO(endDateTime), selectedDate)
                ? PunchesOverviewTypes_1.NEXT_DAY_TEXT
                : '')))));
    return (!(0, isEmpty_1.default)(punchesTimeSegments) && (react_1.default.createElement(Col_1.Col, { dataTestId: PunchesOverviewTypes_1.PUNCHES_OVERVIEW_TEST_ID },
        react_1.default.createElement(Row_1.Row, null,
            react_1.default.createElement(Text_1.Text, { fontSize: "T100", color: "neutral70" }, t('time_and_attendance_DatePicker_punch_legend'))),
        react_1.default.createElement(Row_1.Row, { gridGap: "S300" },
            renderPunchInColumn(),
            renderPunchOutColumn()))));
};
exports.PunchesOverview = PunchesOverview;
